import { useCallback } from 'react';

import { type Board, type Clip } from '@air/api/types';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type AirActionTrackingLocation } from '../types';

export type TrackRemovedClipsFromBoardParams = {
  boardId: Board['id'];
  clipIds: Clip['id'][];
  location: AirActionTrackingLocation;
};

export const useTrackRemovedClipsFromBoard = () => {
  const { track } = useAnalyticsUtilities();

  const trackRemovedClipsFromBoard = useCallback(
    (params: TrackRemovedClipsFromBoardParams) => {
      track(`Removed clips from board`, params, { integrations: { Intercom: true } });
    },
    [track],
  );

  return { trackRemovedClipsFromBoard };
};
